var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCabinCrew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15L14.8125 16.2744L18.766 16.9C19.4349 17.0104 19.9118 17.5286 20.0666 17.774L21.3672 20.5799C21.4415 21.1319 20.9647 21.3313 20.717 21.3619H2.92628C1.88579 21.4723 1.81146 20.8559 1.90436 20.5339L2.97273 18.234C3.11042 17.9418 3.28142 17.7074 3.46457 17.5202C3.89799 17.0773 4.53599 16.9399 5.14707 16.8368L8.76563 16.2267L10.875 15.375",
    stroke: "#D4BC87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 4.64084L8.53125 1.17209C8.59372 0.984591 8.89688 0.647093 9.60938 0.797091L11.7188 1.73459L13.8281 0.797091C13.9953 0.721098 14.5025 0.704242 14.7889 1.04853C14.8051 1.06792 14.8179 1.08984 14.8287 1.11265L16.4531 4.54709",
    fill: "#D4BC87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 4.64084L8.53125 1.17209C8.59373 0.984591 8.89688 0.647093 9.60938 0.797091L11.7188 1.73459L13.8281 0.797091C13.9953 0.721098 14.5025 0.704242 14.7889 1.04853C14.8051 1.06792 14.8179 1.08984 14.8287 1.11265L16.4531 4.54709",
    stroke: "#D4BC87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8134 14.1087L17.2509 6.51497C17.2134 4.56497 15.7353 3.98372 15.0009 3.93685C14.3689 3.89651 9.96373 3.92561 8.74836 3.9345C8.54023 3.93602 8.33413 3.95641 8.13501 4.01694C6.41586 4.53957 6.11445 5.87884 6.18841 6.51497C6.26341 8.31498 5.96966 12.3275 5.81341 14.1087C5.76654 15.0462 7.52901 15.6803 10.2665 15.2806",
    stroke: "#D4BC87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 14.1094C17.8594 15.0469 16.05 15.6649 13.3125 15.2652",
    stroke: "#D4BC87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6593 10.3854C15.4322 11.5737 14.8794 12.8796 14.153 13.8814C13.4123 14.9026 12.5634 15.5136 11.7692 15.5136C11.3805 15.5136 10.9524 15.3547 10.512 15.0459C10.0734 14.7383 9.64381 14.2963 9.26086 13.7706C8.49159 12.7146 7.95114 11.3777 7.88454 10.2469C7.81539 8.64065 8.12656 7.87107 8.67556 7.45935C8.96289 7.24386 9.35026 7.09782 9.86986 7.00806C10.39 6.9182 11.018 6.88867 11.7692 6.88867C13.3517 6.88867 14.4249 7.09473 15.0476 7.59732C15.6263 8.06442 15.9089 8.87555 15.6593 10.3854Z",
    stroke: "#D4BC87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6055 16.2188L12.123 20.8517C11.9817 21.1156 11.6033 21.1156 11.462 20.8517L8.98047 16.2188",
    stroke: "#D4BC87",
    strokeWidth: 0.944444
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28935 16.5C9.11978 16.7528 8.49893 17.2483 7.37198 17.2078L6.86328 18.573L8.7024 18.8764L9.6807 21H11.3633",
    fill: "#D4BC87"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28935 16.5C9.11978 16.7528 8.49893 17.2483 7.37198 17.2078L6.86328 18.573L8.7024 18.8764L9.6807 21H11.3633",
    stroke: "#D4BC87",
    strokeWidth: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3395 16.5C14.5091 16.7528 15.1299 17.2483 16.2569 17.2078L16.7656 18.573L14.9265 18.8764L13.9482 21H12.2656",
    fill: "#D4BC87"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3395 16.5C14.5091 16.7528 15.1299 17.2483 16.2569 17.2078L16.7656 18.573L14.9265 18.8764L13.9482 21H12.2656",
    stroke: "#D4BC87",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinCrew);
export default __webpack_public_path__ + "static/media/cabin-crew.6baf8f411f2f643ad004986811a14018.svg";
export { ForwardRef as ReactComponent };